import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Select } from "components";
import { FETCH_STATE } from "constants/fetchState";

const BiocyclePeriodSelector = ({ onChange, isLoadingData }) => {
  const [selected, setSelected] = useState("");
  const isInitialized = useRef(false);
  const { t } = useTranslation();

  const biocycleOptions = useMemo(() => {
    const options = [
      { value: "2025", label: "2025" },
      { value: "2024", label: "2024" },
    ];
    const currentPeriod = {
      value: "current",
      label: t("FieldsPage.DatePicker.Last12Months"),
    };
    return [currentPeriod, ...options];
  }, [t]);

  useEffect(() => {
    if (biocycleOptions.length) {
      setSelected(biocycleOptions[0].value);
    }
  }, [biocycleOptions]);

  const handleDateChange = useCallback(
    (e) => {
      const newYear = e.target.value;
      setSelected(newYear);

      const dateRange = { start: "", end: "" };
      if (newYear === "current") {
        dateRange.start = moment().add(-1, "year").toISOString();
        dateRange.end = moment().toISOString();
        onChange(dateRange);
        return;
      }
      dateRange.start = new Date(newYear, 0, 1).toISOString();
      dateRange.end = new Date(newYear, 11, 31, 23, 59, 59).toISOString();
      onChange(dateRange);
    },
    [onChange]
  );

  useEffect(() => {
    if (isInitialized.current) {
      return;
    }
    const initiallySelected = biocycleOptions[0]?.value;
    const dateRange = { start: "", end: "" };
    if (initiallySelected === "current") {
      dateRange.start = moment().subtract(1, "year").toISOString();
      dateRange.end = moment().toISOString();
      onChange(dateRange);
      return;
    }
    isInitialized.current = true;
  }, [onChange, biocycleOptions]);

  const isLoading = isLoadingData === FETCH_STATE.LOADING;

  return (
    <Select
      options={biocycleOptions}
      value={selected}
      onChange={handleDateChange}
      isFullWidth={false}
      isDisabled={isLoading}
      sx={{
        "& .select": {
          width: "200px",
        },
      }}
    />
  );
};

export default BiocyclePeriodSelector;
